<script lang="ts">
	import arrowRight from '$lib/assets/images/icons/arrow-right.svg';
	import chevronLeft from '$lib/assets/images/icons/chevron-left.svg';
	import chevronRight from '$lib/assets/images/icons/chevron-right.svg';
	import { Splide, SplideSlide, SplideTrack } from '@splidejs/svelte-splide';
	import '@splidejs/splide/dist/css/splide.min.css';
	import lifeInsurance from '$lib/assets/images/icons/life-insurance.svg';
	import creditInsurance from '$lib/assets/images/icons/credit-insurance.svg';
	import accidentInsurance from '$lib/assets/images/icons/accident-insurance.svg';
	import healthInsurance from '$lib/assets/images/icons/health-insurance.svg';
	import { onMount } from 'svelte';
	import Ideal from '$lib/components/Global/Ideal.svelte';
	import __ from '$lib/stores/TranslationStore';
	import { page } from '$app/stores';

	let options: any = {
		autoplay: true
	};

	onMount(() => {
		options = {
			autoplay: true,
			rewind: true,
			width: '100%',
			gap: '2.5rem',
			perPage: 1,
			pagination: true
		};
	});
</script>

<div class="bg-secondary-bright">
	<div class="container mx-auto py-16">
		<div
			class="items-top justify-left mx-auto flex h-full flex-col overflow-hidden 2xl:container md:flex-row lg:gap-24"
		>
			<div class="flex w-full flex-col gap-16">
				<a
					href="{$page.data?.location?.origin}/simulador/seguro-vida-habitacao"
					class="flex items-center gap-3 text-xs font-semibold uppercase tracking-0.14 text-white lg:text-lg"
				>
					{$__('Fazer simulação')}
					<img src={arrowRight} alt="fazer simulação" />
				</a>
				<h3 class="text-4xl text-white lg:text-5xl lg:leading-54">
					{$__('Qual é o seguro ideal para mim?')}
				</h3>
			</div>
			<div class="max-w-4xl lg:w-2/3 2xl:max-w-5xl">
				<Splide hasTrack={false} {options} class="ideal">
					<SplideTrack>
						<SplideSlide>
							<Ideal
								image={lifeInsurance}
								category={$__('Seguros')}
								title={$__('Seguro de Vida')}
								text={$__(
									'Cuide da sua família hoje e amanhã. Consiga um seguro feito à medida da sua família e proteja-a no caso de uma fatalidade, invalidez ou doenças graves. Negociamos as melhores opções com os nossos parceiros para que poupe na mensalidade e resguarde o futuro.'
								)}
							/>
						</SplideSlide>
						<SplideSlide>
							<Ideal
								image={creditInsurance}
								category={$__('Seguros')}
								title={$__('Seguro de Vida Crédito')}
								text={$__(
									'A sua casa é um pilar de segurança da sua família. Proteja-a de qualquer imprevisto, contratando um seguro com as coberturas certas, em caso de morte, invalidez ou doença grave. Ajudamo-lo a encontrar o seguro certo para si, aos melhores preços, para que viva descansado.'
								)}
							/>
						</SplideSlide>
						<SplideSlide>
							<Ideal
								image={accidentInsurance}
								category={$__('Seguros')}
								title={$__('Seguro Acidentes Pessoais')}
								text={$__(
									'Esteja protegido de qualquer eventualidade, 24h por dia, na esfera pessoal e profissional. Encontramos um seguro personalizado para si, com as coberturas que se adaptam ao seu dia a dia, para que se sinta sempre seguro e sem preocupações.'
								)}
							/>
						</SplideSlide>
						<SplideSlide>
							<Ideal
								image={healthInsurance}
								category={$__('Seguros')}
								title={$__('Seguro de Saúde')}
								text={$__(
									'Proteja o que é mais importante com um seguro de saúde adaptado à sua família. Negociamos os preços e as coberturas que mais se adequam ao seu agregado familiar, para que possa poupar na mensalidade do seguro, sabendo que está apoiado em caso de necessidade.'
								)}
							/>
						</SplideSlide>
					</SplideTrack>
					<div class="splide__arrows z-20 hidden md:block">
						<img
							src={chevronLeft}
							alt="anterior"
							class="splide__arrow splide__arrow--prev ml-11 !h-72 !bg-transparent"
						/>
						<img
							src={chevronRight}
							alt="seguinte"
							class="splide__arrow splide__arrow--next mr-12 !h-72 !bg-transparent"
						/>
					</div>
				</Splide>
			</div>
		</div>
	</div>
</div>
